import FeatureGates from '@atlaskit/feature-gate-js-client';

import { EXTENSION_POINTS_IN_LIVE_PAGES_GATE } from './featureFlags';

export const isLivePagesExtensionPointsEnabled = () => {
	return FeatureGates.checkGate(EXTENSION_POINTS_IN_LIVE_PAGES_GATE);
};
